import { Component, OnInit, Input } from '@angular/core';
import { BlogService } from 'src/app/services/blog.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  @Input() filterByCategory
  defaultImage = `https://dummyimage.com/835x430/9e9e9e.jpg&text=+`
  
  constructor(
    public blogService: BlogService,
    private router: Router,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
  }

}
